import { configureStore } from '@reduxjs/toolkit';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { catchError } from 'rxjs/operators';

// SLICES
import customerDetailsSlice from '../containers/customerDetails/customerDetailsSlice';

// EPICS
import customerDetailsEpics from '../containers/customerDetails/customerDetailsEpics';

const epicMiddleware = createEpicMiddleware();
const epics = combineEpics(...customerDetailsEpics);

const rootEpic = (action$, store$, dependencies) =>
	epics(action$, store$, dependencies).pipe(
		catchError((error, source) => {
			console.error(error);
			return source;
		})
	);

export const store = configureStore({
	reducer: {
		customerDetailsSlice
	},
	middleware: [epicMiddleware]
});

epicMiddleware.run(rootEpic);
